import Guid from "_shared/guids/guid";
import Forum from "messaging/forums/forum";
import AHDate from "_shared/dates/date";
import ForumInvitationSchema, {
  ForumInvitationJSON,
  ForumInvitationParams,
} from "messaging/forums/subscribers/invitations/forum-invitation-schema";
import { ForumInvitationStatus } from "messaging/forums/subscribers/invitations/types";

export default class ForumInvitation {
  public static create(params: ForumInvitationParams): ForumInvitation {
    const parsed = ForumInvitationSchema.validate(params);
    return new ForumInvitation(parsed);
  }

  public static fromJSON(json: ForumInvitationJSON): ForumInvitation {
    const parsed = ForumInvitationSchema.deserialize(json);
    return new ForumInvitation(parsed);
  }

  public readonly id: Guid;
  public readonly inviteeId: Guid;
  public readonly forum: Forum;
  public readonly invitationMessage?: string;
  public readonly createdDate: AHDate;
  public readonly status: ForumInvitationStatus;

  public constructor(params: ForumInvitationParams) {
    this.id = params.id;
    this.inviteeId = params.inviteeId;
    this.forum = Forum.create(params.forum);
    this.invitationMessage = params.invitationMessage;
    this.createdDate = params.createdDate;
    this.status = params.status;
  }

  public toJSON(): ForumInvitationJSON {
    return ForumInvitationSchema.serialize(this);
  }

  public isEqualTo(other: ForumInvitation): boolean {
    if (!other) return false;
    return this.id.isEqualTo(other.id);
  }

  public toString(): string {
    return `ForumInvitation { 
      id: ${this.id.toString()}, 
      inviteeId: ${this.inviteeId.toString()},
      forumId: ${this.forum.id?.toString() ?? "undefined"},
      invitationMessage: ${this.invitationMessage ?? "undefined"},
      createdDate: ${this.createdDate.toISOString()},
      status: ${this.status}
    }`;
  }
}

export class ForumInvitationDoesNotExistError extends Error {
  constructor(id?: Guid | string) {
    if (id instanceof Guid) {
      super(`Forum invitation ${id} does not exist`);
    } else {
      super(`Forum invitation does not exist: ${id}`);
    }
  }
}
